import { getAnonymousID, getSessionID } from "redline-client-sdk";
import { unmask } from "remask";
import type { SortingDebtReqProps } from "./types";
export const transformTrackPayload = ({
	customerIdHash,
	document,
	parameters,
}: SortingDebtReqProps) => ({
	customerIdHash: customerIdHash,
	documento: unmask(document),
	project: "react",
	session_id: getSessionID(),
	anonymous_id: getAnonymousID(),
	application_source: "ac-app",
	parameters,
});
